export default {
    400: {
        title: "Solicitud incorrecta",
        header: "@:views.errors.400.title",
        html: "Solicitud incorrecta. Inténtelo de nuevo más tarde."
    },
    401: {
        title: "Hemos encontrado un error al iniciar sesión.",
        header: "@:views.errors.401.title",
        html: "Por favor, póngase en contacto con <a href='{email}' target='_blank'>el soporte técnico</a> ."
    },
    404: {
        title: "Página no encontrada",
        header: "@:views.errors.404.title"
    },
    403: {
        title: "Acceso no permitido",
        header: "Acceso no permitido",

        contact: "O-I El servicio periférico solo está disponible para empleados. Si usted es empleado y ve este mensaje, contacte con su departamento local de Recursos Humanos y Cultura para actualizar su estado.",

        subject: "Equipo - Elegibilidad",

        html: "<p class='text-start'>@:views.errors.403.eligibility @:views.errors.403.contact</p>",
        error: {
            disabled: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Actualmente no cumples los requisitos. Contacta con <a href='#' role='button' data-widget-trigger='{widgetOptions}'>el equipo de soporte</a> para obtener más información.</p>"
            },
            "not-active": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Actualmente no cumples los requisitos. Consulta con tu oficina local de Cultura para obtener más información.</p>"
            },
            "not-allowed":{
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I El servicio periférico solo está disponible para empleados. Si usted es empleado y ve este mensaje, contacte con su departamento local de Recursos Humanos y Cultura para actualizar su estado.</p>"
            },
            "no-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>No tienes un gerente activo en tu perfil de ServiceNow. Consulta con tu representante local de Recursos Humanos y Cultura para actualizar tu perfil.</p>"
            },
            "self-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Su gerente está configurado como usted en su perfil de ServiceNow. Por favor, contacte a su representante local de Recursos Humanos y Cultura para actualizar su gerente.</p>"
            },
            "no-location": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>No tienes una ubicación registrada en tu perfil de ServiceNow. Consulta con tu representante local de Personas y Cultura para actualizarla.</p>"
            },
            eligibility: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I El servicio periférico solo está disponible para empleados. Si usted es empleado y ve este mensaje, comuníquese con su departamento local de Recursos Humanos para actualizar su estado.</p>",
            },
            "eligibility-location": {
                header: "",
                html: "Gracias por su interés en O-I Periférico. Actualmente, este programa no está disponible en su país.",
            },
            "secondary-account": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Estás intentando acceder a O-I Periférico con una cuenta secundaria. Intenta iniciar sesión de nuevo con tu cuenta principal.</p>"
            },
            "empty-core-id": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Su cuenta de ServiceNow no tiene nombre. Por favor, contacte a su representante local de Personas y Cultura para actualizarla.</p>"
            },
            country: {
                header: "@:views.errors.403.header",
                html: " @:views.errors.403.eligibility @:views.errors.403.contact",
            },
            "no-permissions": {
                header: "Sin acceso",
                subject: "Sin acceso",
                html: "No tienes permisos para abrir esta página.",
            },
            "virtual-denied": {
                header: "Parece que llegaste un poco temprano...",
                html: "<p class='text-start'>Gracias por su interés en O-I Peripheral. Parece que llegó al sitio antes de ser habilitado e invitado directamente. O-I Peripheral se está implementando por etapas, país por país y por grupos de usuarios. Una vez activado, recibirá un correo electrónico con una invitación personal e instrucciones.</p><p class='text-start'> Haga clic en <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Soporte</a> si tiene preguntas o problemas con su pedido o el sitio.</p>",
            }
        }
    },
    500: {
        title: "Error inesperado",
        header: "@:views.errors.500.title",
        message: "Se ha producido un error. Inténtelo de nuevo más tarde."
    },
    code: {
        title: "Error inesperado",
        message: "@:views.errors.code.title",
        error: "Error {code}."
    }
}